// Order Instruction
if ( document.getElementById('cartSpecialInstructions') ) {

  KROWN.saveToSessionStorage = () => {
    const specialInstructions = document.getElementById('cartSpecialInstructions').value;
    sessionStorage.setItem('cartSpecialInstructions', specialInstructions);
  }
  document.getElementById('cartSpecialInstructions').addEventListener('input', KROWN.saveToSessionStorage);

  KROWN.loadFromSessionStorage = () => {
    const savedInstructions = sessionStorage.getItem('cartSpecialInstructions');
      if ( savedInstructions ) {
        document.getElementById('cartSpecialInstructions').value = savedInstructions;
      }
  }
  document.addEventListener('DOMContentLoaded', KROWN.loadFromSessionStorage);

}

// Client Note
if ( document.getElementById('cartClientNotes') ) {

  KROWN.saveToSessionStorage = () => {
    const cartClientNotes = document.getElementById('cartClientNotes').value;
    sessionStorage.setItem('cartClientNotes', cartClientNotes);
  }
  document.getElementById('cartClientNotes').addEventListener('input', KROWN.saveToSessionStorage);

  KROWN.loadFromSessionStorage = () => {
    const cartClientNotes = sessionStorage.getItem('cartClientNotes');
      if ( cartClientNotes ) {
        document.getElementById('cartClientNotes').value = cartClientNotes;
      }
  }
  document.addEventListener('DOMContentLoaded', KROWN.loadFromSessionStorage);
}

// Section Request
// Client Note
if ( document.getElementById('cartSectionRequest') ) {

  KROWN.saveToSessionStorage = () => {
    const cartSectionRequest = document.getElementById('cartSectionRequest').value;
    sessionStorage.setItem('cartSectionRequest', cartSectionRequest);
  }
  document.getElementById('cartSectionRequest').addEventListener('input', KROWN.saveToSessionStorage);

  KROWN.loadFromSessionStorage = () => {
    const cartSectionRequest = sessionStorage.getItem('cartSectionRequest');
      if ( cartSectionRequest ) {
        document.getElementById('cartSectionRequest').value = cartSectionRequest;
      }
  }
  document.addEventListener('DOMContentLoaded', KROWN.loadFromSessionStorage);
}